import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          本周焦点
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          深度专题 · 编辑精选深度内容呈现
        </p>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group cursor-pointer rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 transition-all hover:border-accent-200"
            >
              <div className="relative aspect-[2/1] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-transparent to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 rounded-full bg-accent-500 text-background-50 text-[11px] font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950 group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {item.subtitle}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}